import { stats, voices } from "@/mocks/melonData";

const principles = [
  { icon: "ri-file-search-line", title: "来源优先", desc: "正文标注动态来源与时间，区分官方确认与网络传言。" },
  { icon: "ri-eye-off-line", title: "拒绝标题党", desc: "「进展」与「结果」分开，未证实的绝不提前定论。" },
  { icon: "ri-history-line", title: "持续修正", desc: "每出现一条新线索，我们都回到时间线更新补充。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100/60 border-y border-background-200/60 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-team-line" /> 关于每日有瓜
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">把瓜看清，是我们唯一在做的事</h2>
            <p className="mt-5 max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
              当一件事件成为大家口中的瓜，多数人只看到开头，却很少有人替你把整条线跟到最后。每日有瓜由一群爱较真的内容编辑组成，
              专门追踪事件<strong className="font-semibold text-foreground-950">后续</strong>里每一次<strong className="font-semibold text-foreground-950">反转</strong>与<strong className="font-semibold text-foreground-950">最新进展</strong>，
              把散落在各处的碎片整理成一条看得懂、跟得上的时间线，再给你一个可信的<strong className="font-semibold text-foreground-950">结果</strong>。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {principles.map((p) => (
                <div key={p.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-4">
                  <i className={`${p.icon} text-xl text-primary-500`} />
                  <h3 className="mt-2 text-sm font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="text-left">
                  <p className="font-heading text-2xl text-primary-600">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-2xl text-foreground-950">他们说</h3>
            <p className="mt-2 text-sm text-foreground-600">来自常来吃瓜的读者的真实反馈。</p>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {voices.map((v) => (
                <figure
                  key={v.name}
                  className="rounded-2xl border border-background-200/70 bg-background-50 p-5"
                >
                  <div className="flex gap-0.5 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-6 text-foreground-700">“{v.text}”</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-heading text-accent-800">
                      {v.name.slice(0, 1)}
                    </span>
                    <span>
                      <p className="text-sm font-semibold text-foreground-950">{v.name}</p>
                      <p className="text-xs text-foreground-500">{v.role}</p>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>

            <div id="contact" className="mt-6 flex items-start gap-4 rounded-2xl bg-accent-100/60 p-5">
              <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <i className="ri-mail-send-line text-xl" />
              </span>
              <div>
                <h3 className="text-base font-bold text-foreground-950">想提供线索或投稿？</h3>
                <p className="mt-1 text-sm text-foreground-700">
                  有值得被跟进的瓜，欢迎写信到
                  <a href="mailto:editor@mrgua.example.cn" className="mx-1 font-semibold text-accent-800 hover:underline">
                    editor@mrgua.example.cn
                  </a>
                  ，编辑团队核实后会优先跟进。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}